(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["size-guide"] && !Shopify.designMode) return;
  try {
    (function () {
    function setHeaderBehind(behind) { var header = document.getElementById('header-component'); if (header) header.style.zIndex = behind ? '-1' : ''; }
    function closeOverlay(overlay) { if (!overlay) return; overlay.setAttribute('hidden', ''); document.body.style.overflow = ''; setHeaderBehind(false); }
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('.size-guide__trigger');
      if (trigger) { var overlay = document.getElementById(trigger.getAttribute('aria-controls')); if (overlay) { overlay.removeAttribute('hidden'); document.body.style.overflow = 'hidden'; setHeaderBehind(true); } return; }
      if (event.target.closest('.size-guide__close')) { closeOverlay(event.target.closest('.size-guide__overlay')); return; }
      if (event.target.classList && event.target.classList.contains('size-guide__overlay')) { closeOverlay(event.target); }
    });
    document.addEventListener('keydown', function (event) { if (event.key !== 'Escape') return; closeOverlay(document.querySelector('.size-guide__overlay:not([hidden])')); });
  })();
  } catch(e) { console.error(e); }
})();

})();
